import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

let currentLanguage;
currentLanguage = localStorage.getItem("i18nextLng");

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: currentLanguage || "bn", // Use currentLanguage or fallback to 'en'
    // debug: true, //showing in the console 
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
